var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 256,
    viewBox: "0 0 251 256",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248.24 18.1C240.54 16.42 234.46 10.35 232.79 2.65L232.2 0H18.67L18.09 2.65C16.41 10.35 10.34 16.42 2.64 18.1L0 18.68V237.05L2.64 237.63C10.34 239.31 16.4 245.38 18.09 253.07L18.67 255.72H232.2L232.79 253.07C234.48 245.38 240.54 239.31 248.24 237.63L250.89 237.05V18.68L248.24 18.1ZM246.37 213.09V233.44C237.68 235.68 230.84 242.53 228.59 251.21H22.29C20.03 242.52 13.19 235.68 4.51 233.44V22.3C13.21 20.05 20.05 13.21 22.29 4.52H228.59C230.83 13.21 237.67 20.06 246.37 22.3V213.09Z",
    fill: "url(#paint0_linear_18773_17084)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18773_17084",
    x1: -15.2716,
    y1: 13.8978,
    x2: 275.982,
    y2: 18.9659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E08F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "#FFCF4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716346,
    stopColor: "#FFCF4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08F26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.4eeddcf9803c3651eabb120bf88fcf0a.svg";
export { ForwardRef as ReactComponent };